"use client";

import React from "react";
import { amplitudeTrackEvent } from "@/services/AmplitudeService/AmplitudeService";

export interface IAmplitudeTracker {
  eventName: string;
  eventProperties?: Record<string, any>;
}

export const AmplitudeTracker = ({ eventName, eventProperties }: IAmplitudeTracker) => {
  React.useEffect(() => {
    amplitudeTrackEvent(eventName, eventProperties);
  }, []);

  return <></>;
};
